import { Directive, EventEmitter, HostBinding, HostListener, Input, Output, TemplateRef, ViewContainerRef } from '@angular/core';

@Directive({
	// eslint-disable-next-line @angular-eslint/directive-selector
	selector: '[cdkDetailRow]'
})
export class CdkDetailRowDirective {
	@Input() public openOnClick = true;
	public opened: boolean;
	public row: any;
	public tRef: TemplateRef<any>;
	@Output() public toggleChange = new EventEmitter<CdkDetailRowDirective>();

	constructor(public vcRef: ViewContainerRef) {
	}

	@Input()
	set cdkDetailRow(value: any) {
		if (value !== this.row) {
			this.row = value;
		}
	}

	@HostBinding('class.expanded')
	get expended(): boolean {
		return this.opened;
	}

	// eslint-disable-next-line @angular-eslint/no-input-rename
	@Input('cdkDetailRowTpl')
	set template(value: TemplateRef<any>) {
		if (value !== this.tRef) {
			this.tRef = value;
		}
	}

	@HostListener('click')
	onClick(): void {
		if (this.openOnClick) {
			this.toggle();
		}
	}

	toggle(): void {
		if (this.opened) {
			this.vcRef.clear();
		} else {
			this.render();
		}
		this.opened = this.vcRef.length > 0;
		this.toggleChange.emit(this);
	}

	private render(): void {
		this.vcRef.clear();
		if (this.tRef && this.row) {
			this.vcRef.createEmbeddedView(this.tRef, {$implicit: this.row});
		}
	}
}
